import { FieldArray, FormikProps } from 'formik';
import React from 'react';
import styled from 'styled-components/macro';
import { EmptyPlaceholder } from '../../shared/EmptyPlaceholder';
import { Header4 } from '../../shared/Headers';
import { RightAlignedTh, Table, TBody, Td, THead, Tr } from '../../shared/Table';
import { colourNeutral07 } from '../../styling/colours';
import { EditDesignBillOfMaterialsFormModel } from '../designs/edit-bill-of-materials/editDesignBillOfMaterialsFormModel';
import { ViewOrEditQuoteBillOfMaterialsFormModel } from '../quotes/view-or-edit-bill-of-materials/viewOrEditQuoteBillOfMaterialsFormModel';
import { BillOfMaterialsControlExtraField } from './BillOfMaterialsControlExtraField';
import { ActionButtonTh, DescriptionTh, PartCodeTh } from './BillOfMaterialsItemsTable';
import { BillOfMaterialsOptionalExtraFormModel } from './billOfMaterialsOptionalExtraFormModel';
import { BillOfMaterialsPartsById } from './dataForEditBillOfMaterialsForm';
import { QuantityColumnHeader } from './QuantityColumnHeader';

type Props = {
  controlExtrasArrayFieldName: string;
  controlExtras: Array<BillOfMaterialsOptionalExtraFormModel>;
  partsById: BillOfMaterialsPartsById;
  errors: FormikProps<EditDesignBillOfMaterialsFormModel | ViewOrEditQuoteBillOfMaterialsFormModel>['errors'];
};

export const BillOfMaterialsControlExtrasField = ({
  controlExtrasArrayFieldName,
  controlExtras,
  partsById,
  errors,
}: Props) => (
  <FieldArray name={controlExtrasArrayFieldName}>
    {arrayHelpers => {
      return (
        <>
          <Header4>Control Options</Header4>
          <StyledTable>
            <THead>
              <Tr>
                <PartCodeTh>Part Code</PartCodeTh>
                <QuantityColumnHeader fieldArrayName={controlExtrasArrayFieldName} errors={errors} />
                <DescriptionTh>Description</DescriptionTh>
                <WideCurrencyTh>Price Difference (£)</WideCurrencyTh>
                <ActionButtonTh />
              </Tr>
            </THead>
            <TBody>
              {controlExtras.map((extra, index) => (
                <BillOfMaterialsControlExtraField
                  key={index}
                  fieldName={`${controlExtrasArrayFieldName}.${index}`}
                  controlExtra={extra}
                  partsById={partsById}
                  deleteControlExtra={() => arrayHelpers.remove(index)}
                  errors={errors}
                />
              ))}
              {controlExtras.length === 0 && (
                <Tr>
                  <Td colSpan={5}>
                    <EmptyPlaceholder message="No Control Options have been added to the Bill of Materials." />
                  </Td>
                </Tr>
              )}
            </TBody>
          </StyledTable>
        </>
      );
    }}
  </FieldArray>
);

const StyledTable = styled(Table)`
  table-layout: fixed;
  background-color: ${colourNeutral07};
`;

const WideCurrencyTh = styled(RightAlignedTh)`
  width: 140px;
`;
